var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottomBar"},[_c('Content',{staticClass:"content"},[_c('div',{staticClass:"bottomBar-content"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }